import React, { useEffect, useState } from 'react';
import ReactQuill from 'react-quill';
import EditorToolbar, { modules, formats } from "./quilComponentSubComponents/EditorToolbar";
import 'react-quill/dist/quill.snow.css';
import "./quilComponentSubComponents/style.css";

const QuillComponent = ({ id, value, onStateChanged }) => {
    const [editorValue, setEditorValue] = useState(value || ''); // Initialize with the passed value or empty string

    const handleChange = (value) => {
        setEditorValue(value);
        onStateChanged(value);
    };

    useEffect(() => {
        setEditorValue(value); 
    }, [value]);

    return (
        <div className="text-editor" id={`editor-${id}`}>
            <EditorToolbar toolbarId={`toolbar-${id}`} />
            <ReactQuill
                theme="snow"
                value={editorValue} 
                onChange={handleChange}
                modules={{
                    ...modules,
                    toolbar: `#toolbar-${id}`,
                }}
                formats={formats}
            />
        </div>
    );
};

export default QuillComponent;
